import { render, staticRenderFns } from "./setSex.vue?vue&type=template&id=78bf71f9&"
import script from "./setSex.vue?vue&type=script&lang=js&"
export * from "./setSex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports